import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AgoraConfigService } from 'src/AgoraConfigService';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MomService {
  commonHeaders:any;
  agoraConfigObject: any;
  constructor(private http: HttpClient, private agoraConfig: AgoraConfigService) {
		this.agoraConfigObject = this.agoraConfig.getConfig().endpoints;
      this.commonHeaders = new HttpHeaders().set('Content-Type', 'application/json;charset=utf-8').set("Access-Control-Allow-Origin", "*")
      .set("Access-Control-Allow-Headers", "*")
      .set("Access-Control-Allow-Methods", "GET,POST,PUT,DELETE");
  }

  fetchMomList(meetingId: any) {
      return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.minutes}loadMomList`, { "meetingId": meetingId }, { headers:this.commonHeaders, observe: 'response' });
  }
  fetchApprovedPdf(reqJson:any){
    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.minutes}fetchApprovedPdf`, reqJson, { headers:this.commonHeaders, observe: 'body',responseType: 'blob' as 'json' });
  }
  deleteMinutesAttribute(serviceUrl:any){
      return this.http.delete<any>(`${serviceUrl}`, { headers:this.commonHeaders, observe: 'response' });
  }
  deleteMomDetail(pkMoMDetailId:any){
    return this.http.delete<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.minutes}`+`deleteMomDetail/`+pkMoMDetailId, { headers:this.commonHeaders, observe: 'response' });
}
  saveOrUpdateMomDetail(reqJson:any){
    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.minutes}saveOrUpdateMomDetail`, reqJson, { headers:this.commonHeaders, observe: 'response'});
  }
  copyMomDetail(reqJson:any){
    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.minutes}copyMom`, reqJson, { headers:this.commonHeaders, observe: 'response'});
  }
  computeMomGeneration(reqJson:any){
    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.minutes}computeMomGeneration`, reqJson, { headers:this.commonHeaders, observe: 'response'});
  }
  previewMinutes(reqJson:any){
      const url = `${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.minutes}loadMinutesPreview`;
            // const url = "http://192.168.193.189:9097/loadMinutesPreview";
      const httpOptions = {
          'responseType'  : 'arraybuffer' as 'json'
          //'responseType'  : 'blob' as 'json'
      };
    return this.http.post<any>(url,reqJson,{ headers:this.commonHeaders, observe: 'body',responseType: 'blob' as 'json'});
  }
  viewMoM(reqJson:any){
    const url = `${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.attachment}viewMoM`;
    const httpOptions = {
        'responseType'  : 'arraybuffer' as 'json'
        //'responseType'  : 'blob' as 'json'
    };
  return this.http.post<any>(url,reqJson,{ headers:this.commonHeaders, observe: 'body',responseType: 'blob' as 'json'});
  //return this.http.post<any>(url,reqJson,{ headers:this.commonHeaders, observe: 'response'});
}
fetchMoMSentList(reqJson:any){
  return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.attachment}fetchMoMSentList`, reqJson, { headers:this.commonHeaders, observe: 'response' });
}
  fetchTreeviewMinutes(reqJson: any) {
    //return this.http.post<any>(`${environment.fetchTreeviewMinutes}`, reqJson, { headers:this.commonHeaders, observe: 'response' });
    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.minutes}fetchMinutesByMeetingWithoutUserGrpBy`, reqJson, { headers:this.commonHeaders, observe: 'response' });
  }
  saveTreeviewMinutes(reqJson: any) {
    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.minutes}saveMinutes`, reqJson, { headers:this.commonHeaders, observe: 'response' });
  }
  fetchMoMDetail(meetingId:number) {
    return this.http.get<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.minutes}fetchMoMDetail/`+meetingId, { headers:this.commonHeaders, observe: 'response' });
  }
  fetchMoMDetailListByMeeting(meetingId:number) {
    return this.http.get<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.minutes}fetchMoMDetailListByMeeting/`+meetingId, { headers:this.commonHeaders, observe: 'response' });
  }
  fetchApprovedMinutes(reqJson:any) {
    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.minutes}fetchApprovedMinutes`,reqJson,{ headers:this.commonHeaders, observe: 'response' });
  }
  savePreambleNote(reqJson:any) {
    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.minutes}updatePreamble`,reqJson,{ headers:this.commonHeaders, observe: 'response' });
  }
  updateTaskMinute(reqJson:any) {
    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.task}updateTaskMinute`,reqJson,{ headers:this.commonHeaders, observe: 'response' });
  }
  fetchAgendaMinutesCount(meetingId:any){
    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.agenda}fetchAgendaMinutesCount/`+meetingId,{ headers:this.commonHeaders, observe: 'response' });
  }
  updateNoteMinute(reqJson:any) {
    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.note}updateNoteMinute`,reqJson,{ headers:this.commonHeaders, observe: 'response' });
  }
  updateDecisionMinute(reqJson:any) {
    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.decision}updateDecisionMinute`,reqJson,{ headers:this.commonHeaders, observe: 'response' });
  }
  saveMinutesAsBlob(reqJson:any){
    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.minutes}saveMinutesAsBlob`,reqJson,{ headers:this.commonHeaders, observe: 'response' });
  }
  // fetchSummarizedText(content: string) {
  //   const headers = this.commonHeaders
  //     .set('Content-Type', 'text/plain');
   
  //   return this.http.post<any>(
  //     `${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.agendaSummary}summarize/json-content`,
  //     content,
  //     {
  //       headers,
  //       observe: 'response'
  //     }
  //   );
  // }

  fetchSummarizedText(reqJson:any) {
    // return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.agenda}summarize`,reqJson,{ headers:this.commonHeaders, observe: 'response' });
    return this.http.post<any>(`http://192.168.193.47:2024/agenda/summarize`,reqJson,{ headers:this.commonHeaders, observe: 'response' });
  }

  teamsMeetingDiscussion(reqJson:any) {
    return this.http.get<any>(`${this.agoraConfig.getConfig().endpoints.teamsDiscussion}`+reqJson, { headers:this.commonHeaders, observe: 'response' });
  }

  previeShareAgMinutes(reqJson:any){
      const url = `${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.minutes}PreviewShareAgMinutes`;
      const httpOptions = {
          'responseType'  : 'arraybuffer' as 'json'
          //'responseType'  : 'blob' as 'json'
      };
    return this.http.post<any>(url,reqJson,{ headers:this.commonHeaders, observe: 'body',responseType: 'blob' as 'json'});
  }
}

